/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import DEPLOYMENTS_PRECONDITION_QUERY, {
	type PreconditionCheckQuery,
} from '@jira/software__deployments-precondition/src/__generated__/PreconditionCheckQuery.graphql.ts';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { PreconditionResult } from './PreconditionResult.types.tsx';

const RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';

const RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION_RELAY = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';

export const deploymentPreconditionResource: RouteResource<PreconditionResult> =
	createResource<PreconditionResult>({
		type: RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION,
		getKey: ({ query }) => query.projectKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-deployments-precondition", jiraSpaEntry: "async-resource-deployments-precondition" */ './getData.tsx'
			),
		maxAge: 60 * 1000,
	});

export const deploymentPreconditionRelayResource: RouteResource<
	PreloadedQuery<PreconditionCheckQuery, Record<string, unknown>>
> = createRelayResource<PreconditionCheckQuery>({
	type: RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION_RELAY,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: DEPLOYMENTS_PRECONDITION_QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
			projectKey: String(match.params.projectKey),
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
